import { api } from './services';

export const saveSystemMaintenance = async (reqBody: { systemMaintenanceIds: number[], isDisabled: number }) => await api('maintenance/save', reqBody, 'post');
export const fetchSystemMaintenance = async () => await api('maintenance/getAll', {}, 'get');
